<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/18o4ja6/tc-custom/9781555848262.jpg?1720464482235" alt="This image is the cover for the book Delivery Man"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Delivery Man
      </h1>
      <p class="bookDescription body article font2">
        <b>“A gripping literary thriller and an auspicious debut” set against the surreal excess of Las Vegas from the author of <i>Carousel Court</i> (George Pelecanos, author and award-winning writer/producer of <i>The Wire</i>).</b><br/>  <br/> After attending college in New York, Chase returns to Vegas and is drawn into the lucrative but dangerous world of a teenage call-girl service with his childhood friend Michele, a beautiful Salvadoran immigrant with whom he shares a tragic past. Over the course of one extraordinary summer, they will confront the violence and emptiness at the heart of the city and their generation.<br/>  <br/> At once stark and electrically atmospheric, horrifying and hopeful, <i>The Delivery Man</i> is an ambitious literary novel as well as a fast and absorbing page-turner—and a powerful indictment of a society in which personal responsibility has been abandoned, lust is increasingly mistaken for love, and innocence is an anachronism.<br/>  <br/> “A dead-of-night story surehandedly told in a pared-down, teeth-bared style reminiscent of Joan Didion.” —Janet Fitch, <i>New York Times</i>–bestselling author of <i>White Oleander</i><br/>  <br/> “[A] brisk, bleak debut novel . . . offers unflinching glimpses at mores in free fall . . . searing . . . memorable . . . not for the faint of heart.” —<i>The New York Times Book Review</i><br/>  <br/> “McGinniss offers a fresh take on the seamy side of Vegas by focusing on the wasted lives of burned-out teens hooked on drugs and money.” —<i>USA Today</i><br/>  <br/> “It’s sex, drugs, and a slew of lost souls . . . engrossing . . . Could <i>The Delivery Man</i> be this decade’s <i>Less Than Zero</i>?” —<i>Marie Claire</i><br/>  <br/> “Grim, convincing, and compelling . . . <i>The Delivery Man</i> really delivers.” —<i>The Washington Post</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joe McGinniss
      </h2>
      
      <p class="authorDescription body article">Joe McGinniss Jr. graduated from Swarthmore College and lives in Washington, DC.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Black Cat
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2465addd